import React from 'react';
import './Header.css';
import headerlogo from '../assets/logo.svg';

const Header = () => {
    return (
        <header className="site-header">
            <div className="site-header__container">
                <div className="site-logo">
                    <a href="/">
                        <img src={headerlogo} alt="Site Logo" />
                    </a>
                </div>
            </div>
        </header>
    );
};

export default Header;
